import React, {FC} from 'react';
import styled from 'styled-components';
import {Helmet} from 'react-helmet';
import ReactSlick from 'react-slick';

import {StylableProps} from '../../../lib/styleHelpers';

interface SliderProps {
  items: any;
  settings: any;
  innerRef?: any;
}

const StyledSlider = styled(ReactSlick)`
  width: 100%;
  .slick-track {
    display: flex;
  }
  .slick-dots {
    li {
      width: 16px;
      height: 16px;
      button:before {
        font-size: 8px;
      }
    }
  }
`;

// TODO: find a way to import slick css from node_modules (e.g. import('../react-slick/...css'))
export const Slider: FC<SliderProps & StylableProps> = props => {
  const {items, settings, className, innerRef} = props;

  return (
    <>
      <Helmet
        link={[
          {
            rel: 'stylesheet',
            type: 'text/css',
            href: 'https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css'
          },
          {
            rel: 'stylesheet',
            type: 'text/css',
            href: 'https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick-theme.min.css'
          }
        ]}
      />
      <StyledSlider {...settings} className={className} ref={innerRef}>
        {items}
      </StyledSlider>
    </>
  );
};
